// extracted by mini-css-extract-plugin
export var active = "styles-module--active--7c0f7";
export var column = "styles-module--column--b4f5e";
export var column1 = "styles-module--column1--59ccd";
export var column2 = "styles-module--column2--0e10b";
export var container = "styles-module--container--ffbbb";
export var filled = "styles-module--filled--70e87";
export var row = "styles-module--row--4c39b";
export var row1 = "styles-module--row1--a86cd";
export var row2 = "styles-module--row2--7222a";